import { combineReducers } from 'redux';
import {reducer as formReducer} from 'redux-form';

import authReducer from './authReducer';
import issuerReducer from './issuerReducer';
import badgeClassReducer from './badgeClassReducer';
import badgeClassesReducer from './badgeClassesReducer';
import assertionReducer from './assertionReducer';
import assertionsReducer from './assertionsReducer';

export default combineReducers ({
	auth: authReducer,
	issuer: issuerReducer,
	badgeClass: badgeClassReducer,
	badgeClasses: badgeClassesReducer,
	form: formReducer,
	assertions: assertionsReducer,
	assertion: assertionReducer,
})


// WEBPACK FOOTER //
// ./src/reducers/index.js